import React from 'react';
import { asyncComponent } from 'js/file_viewer/core/utils/suspense';
import { useDownloadSucceeded } from 'js/file_viewer/hooks/lifecycle_logging';
const AsyncPreviewHTML = asyncComponent('PreviewHTML', () => import('js/file_viewer/preview_html/preview_html'));
export const AsyncPreviewHTMLWithRivieraFetch = (props) => {
    // HTML previews do not make any Riviera fetches so we can log download
    // succeeded immediately.
    useDownloadSucceeded(props.previewSessionId, true);
    return React.createElement(AsyncPreviewHTML, { ...props });
};
AsyncPreviewHTMLWithRivieraFetch.displayName = "AsyncPreviewHTMLWithRivieraFetch"
//# sourceMappingURL=async_preview_html.preenvesnextjs.map
